import React, { useEffect, useRef } from "react";

export default function HappyMeterForm({ userData }) {
  const formRef = useRef(null);
  useEffect(() => {
    if (userData.data) {
      formRef.current.submit();
    }
  }, [userData.data]);

  return (
    <>
            <form ref={formRef} method="post"
      id="happy-meter-form" action={userData.data.postUrl}>
                <input type="hidden" name="json_payload" id="json_payload" value={userData.data.jsonPayload} />
                <input type="hidden" name="client_id" id="client_id" value={userData.data.clientId} />
                <input type="hidden" name="signature" id="signature" value={userData.data.signature} />
                <input type="hidden" name="lang" id="lang" value={userData.data.lang} />
                <input type="hidden" name="random" id="random" value={userData.data.random} />
                <input type="hidden" name="timestamp" id="timestamp" value={userData.data.timestamp} />
                <input type="hidden" name="nonce" id="nonce" value={userData.data.nonce} />
            </form>
             
        </>);

}